export default { sha: '3b9baee97785758f72cc65da6a1de9c939c5d6cd', buildNumber: 'undefined' }
